export enum Scopes {
  INTERACTIONS_READ = 'interactions:read',
  INTERACTIONS_WRITE = 'interactions:write',
}
